import { Container, TextField, Paper, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import React, { useState, useEffect, useContext } from "react";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import api from "../../services/api";
import { toast } from "react-toastify";
import ButtonWithSpinner from "../../components/ButtonWithSpinner";
import PorClientePDF from "./Template/PorClientePDF";
import PDF from "../../helpers/PDF";
import { AuthContext } from "../../context/Auth/AuthContext";
import PorClienteDescricaoCompletaInternaPDF from "./Template/PorClienteDescricaoCompletaInternaPDF";

const filterOptions = createFilterOptions({
  trim: true,
});

const listaMotivoClassificacao = [
  "Dúvida",
  "Erro",
  "Treinamento",
  "Desenvolver",
  "Configurar",
  "Outros",
  "Atualizar",
];

const PorClienteDescricaoCompletaInterna = () => {
  const { user: loggedInUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [loadingImprimir, setLoadingImprimir] = useState(false);

  // #region Periodo de Data e Hora
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [initialSelectedDate, setInitialSelectedDate] =
    useState(getCurrentDate);
  const [finalSelectedDate, setFinalSelectedDate] = useState(getCurrentDate);

  const [initialSelectedTime, setInitialSelectedTime] = useState("00:00");
  const [finalSelectedTime, setFinalSelectedTime] = useState("23:59");
  // #endregion Periodo de Data e Hora

  // #region Pessoa
  const [optionsPessoa, setOptionsPessoa] = useState([]);
  const [textoPesquisaPessoa, setTextoPesquisaPessoa] = useState("");
  const [pessoaSelecionada, setPessoaSelecionada] = useState(null);
  // #endregion Pessoa

  // #region PlataformaSistema
  const [optionsPlataformaSistema, setOptionsPlataformaSistema] = useState([]);
  const [textoPesquisaPlataformaSistema, setTextoPesquisaPlataformaSistema] =
    useState("");
  const [plataformaSistemaSelecionada, setPlataformaSistemaSelecionada] =
    useState(null);
  // #endregion PlataformaSistema

  // #region ModuloFuncionalidade
  const [optionsModuloFuncionalidade, setOptionsModuloFuncionalidade] =
    useState([]);
  const [
    textoPesquisaModuloFuncionalidade,
    setTextoPesquisaModuloFuncionalidade,
  ] = useState("");
  const [moduloFuncionalidadeSelecionada, setModuloFuncionalidadeSelecionada] =
    useState(null);
  // #endregion ModuloFuncionalidade

  // #region SlaPrioridade
  const [optionsSlaPrioridade, setOptionsSlaPrioridade] = useState([]);
  const [textoPesquisaSlaPrioridade, setTextoPesquisaSlaPrioridade] =
    useState("");
  const [slaPrioridadeSelecionada, setSlaPrioridadeSelecionada] =
    useState(null);
  // #endregion SlaPrioridade

  // #region MotivoClassificacao
  const [motivoClassificacaoSelecionada, setMotivoClassificacaoSelecionada] =
    useState(null);
  // #endregion MotivoClassificacao

  // #region Campos Textos Descricao
  const [textoDescricao, setTextoDescricao] = useState("");
  // #endregion Campos Textos Descricao

  // #region Usuario
  const [optionsUsuario, setOptionsUsuario] = useState([]);
  const [textoPesquisaUsuario, setTextoPesquisaUsuario] = useState("");
  const [usuarioSelecionada, setUsuarioSelecionada] = useState(null);
  // #endregion Usuario

  // #region Change dos AutoCompletes...
  // PESSOA
  useEffect(() => {
    if (textoPesquisaPessoa.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-pessoa/", {
            params: { texto: textoPesquisaPessoa },
          });

          setOptionsPessoa(data.pessoas);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaPessoa]);

  // PLATAFORMA/SISTEMA
  useEffect(() => {
    if (textoPesquisaPlataformaSistema.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-plataformasistema/", {
            params: { texto: textoPesquisaPlataformaSistema },
          });

          setOptionsPlataformaSistema(data.plataformaSistema);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaPlataformaSistema]);

  // MODULO/FUNCIONALIDADE
  useEffect(() => {
    if (textoPesquisaModuloFuncionalidade.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get(
            "/autocomplete-modulofuncionalidade/",
            {
              params: { texto: textoPesquisaModuloFuncionalidade },
            }
          );

          setOptionsModuloFuncionalidade(data.moduloFuncionalidade);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaModuloFuncionalidade]);

  // SLA PRIORIDADE
  useEffect(() => {
    if (textoPesquisaSlaPrioridade.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-slaprioridade/", {
            params: { texto: textoPesquisaSlaPrioridade },
          });

          setOptionsSlaPrioridade(data.slaPrioridade);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaSlaPrioridade]);

  // USUARIO
  useEffect(() => {
    if (textoPesquisaUsuario.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-usuario/", {
            params: { texto: textoPesquisaUsuario },
          });

          setOptionsUsuario(data.usuarios);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaUsuario]);
  // #endregion Change dos AutoCompletes...

  const handleSugerirSlaPrioridade = async (campoOrigem, valorAtual) => {
    setLoading(true);
    try {
      let data = {};

      if (valorAtual) {
        if (campoOrigem === "motivo" && moduloFuncionalidadeSelecionada.id) {
          data.motivoClassificacaoBuscar = valorAtual;
          data.idModuloFuncionalidadeBuscar =
            moduloFuncionalidadeSelecionada.id;
        } else if (campoOrigem === "modulo" && motivoClassificacaoSelecionada) {
          data.motivoClassificacaoBuscar = motivoClassificacaoSelecionada;
          data.idModuloFuncionalidadeBuscar = valorAtual.id;
        }
      }

      if (
        data &&
        Object.keys(data).length > 0 &&
        data.idModuloFuncionalidadeBuscar &&
        data.motivoClassificacaoBuscar
      ) {
        const retornoSlaPrioridade = await api.get("/obter-slaprioridade/", {
          params: data,
        });
        setSlaPrioridadeSelecionada(retornoSlaPrioridade.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error);
    }
  };

  const handleImprimirRelatorio = async () => {
    try {
      setLoadingImprimir(true);

      const retornoDados = await api.get(
        "/relatorio-por-cliente-descricao-completa-interna",
        {
          params: {
            idPessoa: pessoaSelecionada ? pessoaSelecionada.id : null,
            descricao: textoDescricao ?? null,
            idPlataformaSistema: plataformaSistemaSelecionada
              ? plataformaSistemaSelecionada.id
              : null,
            idModuloFuncionalidade: moduloFuncionalidadeSelecionada
              ? moduloFuncionalidadeSelecionada.id
              : null,
            motivoClassificacao:
              motivoClassificacaoSelecionada === undefined
                ? null
                : motivoClassificacaoSelecionada,
            idSlaPrioridade: slaPrioridadeSelecionada
              ? slaPrioridadeSelecionada.id
              : null,
            idUsuario: usuarioSelecionada ? usuarioSelecionada.id : null,
            dataHoraInicial: `${initialSelectedDate} ${initialSelectedTime}`,
            dataHoraFinal: `${finalSelectedDate} ${finalSelectedTime}`,
          },
        }
      );

      if (!retornoDados || !retornoDados.data) {
        setLoadingImprimir(false);
        toast.info("Relatório sem dados!");
        return;
      }

      const relatorio = await PDF({
        documento: (
          <PorClienteDescricaoCompletaInternaPDF
            dados={retornoDados.data.retorno}
            user={loggedInUser}
          />
        ),
      });

      relatorio.AbrirArquivo();

      setLoadingImprimir(false);
    } catch (error) {
      toast.error("Ocorreu um erro!");
      setLoadingImprimir(false);
    }
  };

  return (
    <>
      <Typography variant="h6" style={{ marginLeft: 30, marginBottom: 5 }}>
        Por Cliente - Descrição Completa e Interna
      </Typography>
      <Container style={{ width: "100%" }}>
        <Paper
          elevation={12}
          style={{
            padding: "30px 30px 30px 30px",
          }}
          loading={loading}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <TextField
                style={{ width: 350, marginBottom: 20 }}
                label={"Data inicial"}
                type="date"
                value={initialSelectedDate}
                onChange={(e) => setInitialSelectedDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
              <TextField
                style={{ width: 190, marginBottom: 20, marginLeft: 10 }}
                label={"Horário inicial"}
                type="time"
                value={initialSelectedTime}
                onChange={(e) => setInitialSelectedTime(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
            </div>
            <div>
              <TextField
                style={{ width: 350, marginBottom: 20 }}
                label={"Data final"}
                type="date"
                value={finalSelectedDate}
                onChange={(e) => setFinalSelectedDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
              <TextField
                style={{ width: 190, marginBottom: 20, marginLeft: 10 }}
                label={"Horário final"}
                type="time"
                value={finalSelectedTime}
                onChange={(e) => setFinalSelectedTime(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Autocomplete
              style={{ width: 550, marginBottom: 20 }}
              getOptionLabel={(option) =>
                `${
                  option.nomeFantasia ||
                  option.nomeRazaoSocial ||
                  pessoaSelecionada.nomeFantasia ||
                  pessoaSelecionada.nomeRazaoSocial
                }`
              }
              onChange={(e, newValue) => {
                setPessoaSelecionada(newValue);
              }}
              id="pessoaSelecionada"
              name="pessoaSelecionada"
              value={pessoaSelecionada}
              options={optionsPessoa}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Digite para buscar um cliente"
                  variant="outlined"
                  onChange={(e) => setTextoPesquisaPessoa(e.target.value)}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <Autocomplete
              style={{ width: 550, marginBottom: 20 }}
              getOptionLabel={(option) =>
                `${option.descricao || plataformaSistemaSelecionada.descricao}`
              }
              onChange={(e, newValue) => {
                setPlataformaSistemaSelecionada(newValue);
              }}
              id="plataformaSistemaSelecionada"
              name="plataformaSistemaSelecionada"
              value={plataformaSistemaSelecionada}
              options={optionsPlataformaSistema}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Plataforma ou sistema"
                  variant="outlined"
                  onChange={(e) =>
                    setTextoPesquisaPlataformaSistema(e.target.value)
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Autocomplete
              style={{ width: 550, marginBottom: 20 }}
              getOptionLabel={(option) =>
                `${
                  option.descricao || moduloFuncionalidadeSelecionada.descricao
                }`
              }
              onChange={async (e, newValue) => {
                setModuloFuncionalidadeSelecionada(newValue);
                await handleSugerirSlaPrioridade("modulo", newValue);
              }}
              id="moduloFuncionalidadeSelecionada"
              name="moduloFuncionalidadeSelecionada"
              value={moduloFuncionalidadeSelecionada}
              options={optionsModuloFuncionalidade}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Modulo ou funcionalidade"
                  variant="outlined"
                  onChange={(e) =>
                    setTextoPesquisaModuloFuncionalidade(e.target.value)
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <Autocomplete
              style={{ width: 550, marginBottom: 20 }}
              id="motivoClassificacao"
              name="motivoClassificacao"
              label="Motivo (Classificação)"
              variant="outlined"
              value={motivoClassificacaoSelecionada}
              onChange={async (e, newValue) => {
                setMotivoClassificacaoSelecionada(newValue);
                await handleSugerirSlaPrioridade("motivo", newValue);
              }}
              options={listaMotivoClassificacao.map((motivo) => motivo)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Motivo (Classificação)"
                  variant="outlined"
                />
              )}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Autocomplete
              style={{ width: 550, marginBottom: 20 }}
              getOptionLabel={(option) =>
                `${option.descricao || slaPrioridadeSelecionada.descricao}`
              }
              onChange={(e, newValue) => {
                setSlaPrioridadeSelecionada(newValue);
              }}
              id="slaPrioridadeSelecionada"
              name="slaPrioridadeSelecionada"
              value={slaPrioridadeSelecionada}
              options={optionsSlaPrioridade}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Digite para buscar um sla"
                  variant="outlined"
                  onChange={(e) =>
                    setTextoPesquisaSlaPrioridade(e.target.value)
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <TextField
              style={{ width: 550, marginBottom: 10 }}
              id="descricao"
              name="descricao"
              label={"Descrição do Ticket (Título contém)"}
              variant="outlined"
              value={textoDescricao}
              onChange={(e) => setTextoDescricao(e.target.value)}
              inputProps={{ maxLength: 100 }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Autocomplete
              style={{ width: 550, marginBottom: 20 }}
              getOptionLabel={(option) =>
                `${option.name || usuarioSelecionada.name}`
              }
              onChange={(e, newValue) => {
                setUsuarioSelecionada(newValue);
              }}
              id="usuarioSelecionada"
              name="usuarioSelecionada"
              value={usuarioSelecionada}
              options={optionsUsuario}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Digite para buscar um usuário"
                  variant="outlined"
                  onChange={(e) => setTextoPesquisaUsuario(e.target.value)}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <ButtonWithSpinner
              variant="contained"
              type="button"
              onClick={() => handleImprimirRelatorio()}
              color="primary"
              loading={loadingImprimir}
            >
              {"Imprimir"}
            </ButtonWithSpinner>
          </div>
        </Paper>
      </Container>
    </>
  );
};

export default PorClienteDescricaoCompletaInterna;
